export const ACTIONS = "actions";
export const ALL_CATEGORIES = "__all__";